export default {
    setFavourites(state, payload) {
        state.favouritesArr = payload;
    }
};
